import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import useSmoothScroll from "@/components/motion/useSmoothScroll";
import Reveal from "@/components/motion/Reveal";

export default function PolicyLayout({ eyebrow, title, italic, lastUpdated, children }) {
  useSmoothScroll();
  return (
    <main className="relative bg-[#08080A] text-neutral-100 min-h-screen">
      <Header />

      {/* Hero */}
      <section className="relative pt-40 md:pt-56 pb-16 md:pb-24 border-b border-white/8">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <Reveal className="max-w-4xl">
            <Link
              to="/"
              className="link-gold inline-flex items-center gap-2 text-xs tracking-[0.24em] uppercase text-neutral-400 mb-10"
            >
              <ArrowLeft className="w-4 h-4" /> Return Home
            </Link>
            <div className="overline mb-6">{eyebrow}</div>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] text-neutral-50">
              {title}{" "}
              {italic && <span className="italic text-[#D4AF37]">{italic}</span>}
            </h1>
            {lastUpdated && (
              <div className="mt-8 text-xs tracking-[0.24em] uppercase text-neutral-500">
                Last updated · {lastUpdated}
              </div>
            )}
          </Reveal>
        </div>
      </section>

      {/* Body */}
      <section className="py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-3 md:sticky md:top-32 md:self-start">
              <div className="overline text-neutral-500">Rudra Empire</div>
              <div className="font-display italic text-2xl text-neutral-100 leading-tight mt-3">
                A private house of land.
              </div>
              <div className="mt-6 text-xs text-neutral-500 leading-relaxed">
                Registered in Karnataka, India.<br />
                For queries: <a href="mailto:info@rudraempire.com" className="link-gold text-neutral-300">info@rudraempire.com</a>
              </div>
            </div>
            <div className="md:col-span-9">
              <Reveal>
                <article className="prose-policy space-y-10 text-neutral-300 leading-relaxed">
                  {children}
                </article>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}

export function Section({ number, title, children }) {
  return (
    <section>
      <div className="flex items-start gap-5 mb-5">
        <div className="font-display italic text-[#D4AF37] text-3xl leading-none pt-1 shrink-0 w-14">
          {number}
        </div>
        <div>
          <h2 className="font-display text-2xl md:text-3xl text-neutral-50 leading-tight">
            {title}
          </h2>
        </div>
      </div>
      <div className="pl-0 md:pl-[76px] space-y-4 text-base md:text-[17px] leading-[1.75]">
        {children}
      </div>
    </section>
  );
}
